import { observer } from 'mobx-react-lite'
import { namingConfig } from '@gap/utils/config/naming-config'
import GapAlert from 'reusable/mui/alert/GapAlert'
import GapDialog from 'reusable/gap-dialog/GapDialog'
import { useAdvisorIntegrationFYIStore } from './AdvisorIntegrationFYIStore'
import FYISyncModeOptions, { FYISwitchSourceWarning } from './FYISyncModeOptions'

/** Lets a connected org switch between storing documents only and syncing clients too. */
export default observer(function AdvisorIntegrationFYIManageDialog() {
   const advisorIntegrationFYIStore = useAdvisorIntegrationFYIStore()
   const stopsSyncingClients = advisorIntegrationFYIStore.isClientSource && advisorIntegrationFYIStore.syncMode === 'documents'

   return <GapDialog
      size="small"
      title="Change what syncs from FYI"
      subTitle="Your keys stay connected."
      modalState={advisorIntegrationFYIStore.manageDialog}
      cancel
      primary={advisorIntegrationFYIStore.managePrimaryGapDialogButton}
   >
      <FYISyncModeOptions variant="manage" />
      {advisorIntegrationFYIStore.needsSwitchAcknowledgement && <FYISwitchSourceWarning />}
      {stopsSyncingClients && <GapAlert severity="warning" title="Clients will stop syncing from FYI" sx={{ mt: 2 }}>
         Existing clients stay in {namingConfig.product.singular} but won't get updates until you set a new client source.
      </GapAlert>}
   </GapDialog>
})
